// extracted by mini-css-extract-plugin
export var active = "_55-a";
export var activeIndicator = "_55-9";
export var disabled = "_55-b";
export var fullWidth = "_55-2";
export var lg = "_55-7";
export var md = "_55-6";
export var redoButtonTabGroup = "_55-0";
export var sm = "_55-5";
export var tabButton = "_55-4";
export var tabButtonsContainer = "_55-1";
export var themeDestructive = "_55-d";
export var themeNormal = "_55-c";
export var themeSuccess = "_55-e";
export var xl = "_55-8";
export var xs = "_55-3";